var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeftToLine = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.25 4a.75.75 0 0 0-1.5 0v8a.75.75 0 0 0 1.5 0zm9.5 4a.75.75 0 0 0-.75-.75H7.81l1.22-1.22a.75.75 0 1 0-1.06-1.06L5.482 7.458A.75.75 0 0 0 5.47 8.53l2.5 2.5a.75.75 0 0 0 1.06-1.06L7.81 8.75H13a.75.75 0 0 0 .75-.75"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeftToLine);
export default ForwardRef;